// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2E6ai","row":"styles_row__25h-f"};